import Recoil from 'recoil';
import localStorageEffect from './localStorageEffect';
const remember_me = Recoil.atom({
  key: 'app.remember_me',
  default: false,
  effects: [
    localStorageEffect('_K', false, { initial: false, encryption: true, type: 'boolean' }),
  ]
});
export default remember_me;